<div class="errorPage">
  <app-error-page error="500"></app-error-page>
</div>
